export const CancelReasons: Record<string, string> = {
    'deadlinePassed': 'Deadline passed',
    'materialChange': 'Did not respond to material change',
    'adminCancelled': 'Admin Cancel',
}
